module.exports = __webpack_public_path__ + "static/BannerHero_mobile2x-2a0fa40c26a100db6b246baf59399aaf.jpg";